<template>
  <el-dialog
    :visible.sync="showDialog"
    append-to-body
    class="dialog-binduserinfotip"
    title=""
    top="0"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleCloseDialog"
    :show-close="false"
  >
    <template slot="title">
      <img
        class="icon-delete"
        src="@/assets/icon_dialog_delete.png"
        @click="handleCloseDialog"
      />
    </template>
    <div class="dialog-container">
      <img class="icon-remind" src="@/assets/icon_remind_yellow.png" />
      <div class="title-box">温馨提示</div>
      <div class="tip-box">
        你还没有绑定微信账户，绑定成功后，<br />即可申请提现！
      </div>
       <el-button
          class="custom-button btn-ff3333 btn-tobind"
          @click="handleToBind"
          >去绑定</el-button
        >
    </div>
    <DialogBindUserInfoQrcode ref="dialogBindUserInfoQrcode" @CloseDialog="bindCallbck"></DialogBindUserInfoQrcode>
  </el-dialog>
</template>
<script>
import storage from "@/utils/customLocalStorage";
import { phoneValidator } from "@/assets/js/util";
import pageCommon from "@/utils/pagecommon";
import imgCodeApi from "@/api/imgcode";
import accountApi from "@/api/account";
import sendpohnecodeMixin from "@/views/mixins/sendphonecode";
import DialogBindUserInfoQrcode from "@/components/dialog/BindUserInfoQrcode";
export default {
  name: "BindUserInfoTip",
  mixins: [sendpohnecodeMixin],
  components:{
    DialogBindUserInfoQrcode,
  },
  data() {
    return {
      showDialog: false,
      formData: {
        content: "",
      },
      //发送验证码操作
      sendphoneValideForName: "modifyForm",
      sendPhoneFormeDataName: "formData",
      valideFieldPhoneItemName: "user_phone",
      //发送验证码结束------------------------
      imgCodeUrl: "",
      rules: {
        user_phone: [
          { required: true, message: "填写正确的手机号码", trigger: "blur" },
          { validator: phoneValidator, trigger: "blur" },
        ],
        msg_content: [
          { required: true, message: "填写手机验证码", trigger: "blur" },
        ],
        pic_code: [{ required: true, message: "填写验证码", trigger: "blur" }],
        password_user: [
          { required: true, message: "填写密码", trigger: "blur" },
        ],
      },
      isRequesting: false,
    };
  },
  mounted() {

  },
  methods: {
   
    handleToBind: function () {
      let _this = this;
      _this.$refs.dialogBindUserInfoQrcode.showDialog=true;
    },

    handleCloseDialog: function () {
      let _this = this;
      _this.showDialog = false;
    },
    bindCallbck:function(){
      let _this=this;
      
    }

  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.dialog-binduserinfotip {
  /deep/.el-dialog {
    position: absolute;
    width: 420px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    .el-dialog__header {
      position: relative;
      width: 420px;
      padding: 0;
      padding-top: 30px;
      padding-right: 30px;
      padding-bottom: 2px;
      box-sizing: border-box;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      justify-content: flex-end;
      .icon-delete {
        position: relative;
        width: 16px;
        height: 16px;
        cursor: pointer;
      }
    }
    .el-dialog__body {
      position: relative;
      width: 100%;
      padding: 0;
      padding-bottom: 67px;
      box-sizing: border-box;
      .dialog-container {
        position: relative;
        width: 100%;
        text-align: center;
        .icon-remind {
          position: relative;
          display: block;
          width: 70px;
          height: 70px;
          margin: 0 auto;
        }
        .title-box {
          position: relative;
          width: 100%;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #222222;
          line-height: 20px;
          text-align: center;
          margin-top: 20px;
        }
        .tip-box {
          position: relative;
          width: 100%;
          height: 42px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: normal;
          color: #222222;
          line-height: 26px;
          text-align: center;
          margin-top: 36px;
        }
        .btn-tobind{
          width: 160px;
height: 46px;
line-height: 46px;
text-align: center;

font-size: 16px;
font-family: Source Han Sans CN;
font-weight: 400;
color: #FFFFFF;
margin:63px auto 0;

        }
      }
    }

  }
}
</style>